// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pycnometer-profiles-page {
  padding: 16px;
}
.pycnometer-profiles-page .page-title {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 1.25rem;
}
.pycnometer-profiles-page .spinner-container {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}
.pycnometer-profiles-page .two-panel-layout {
  display: grid;
  grid-template-columns: minmax(280px, 380px) 1fr;
  gap: 24px;
  align-items: start;
}
.pycnometer-profiles-page .two-panel-layout .left-panel,
.pycnometer-profiles-page .two-panel-layout .right-panel {
  min-height: 400px;
}
.pycnometer-profiles-page .two-panel-layout .left-panel {
  border-right: 1px solid var(--p-surface-200, #e0e0e0);
  padding-right: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/pycnometer-profiles/pycnometer-profiles-page.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AAEE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAAJ;AAGE;EACE,aAAA;EACA,+CAAA;EACA,SAAA;EACA,kBAAA;AADJ;AAGI;;EAEE,iBAAA;AADN;AAII;EACE,qDAAA;EACA,mBAAA;AAFN","sourcesContent":[".pycnometer-profiles-page {\n  padding: 16px;\n\n  .page-title {\n    margin-top: 0;\n    margin-bottom: 20px;\n    font-size: 1.25rem;\n  }\n\n  .spinner-container {\n    display: flex;\n    justify-content: center;\n    padding: 24px 0;\n  }\n\n  .two-panel-layout {\n    display: grid;\n    grid-template-columns: minmax(280px, 380px) 1fr;\n    gap: 24px;\n    align-items: start;\n\n    .left-panel,\n    .right-panel {\n      min-height: 400px;\n    }\n\n    .left-panel {\n      border-right: 1px solid var(--p-surface-200, #e0e0e0);\n      padding-right: 16px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
